<template>
  <StepTwoDialog ref="dialog" openBtnName="填写" @input="handleAcceptStep" @before-close="handleFinish"  @closed="handleDialogClose">
    <div slot="title" class="cc-title">填写邮件地址</div>
    <el-form label-width="100px" class="demo-ruleForm" :model="form" :rules="rules" ref="form" hide-required-asterisk>
      <el-form-item  label="邮件地址" prop="newData"  :rules="[
      { required: true, message: '请输入邮件地址', trigger: 'blur' },
      { type: 'email', message: '请输入正确的邮件地址', trigger: ['blur', 'change'] }
    ]">
     <el-col>
      <el-input
        v-noSpace
        placeholder="请输入邮件地址"
        v-model.trim="form.newData"
         />
     </el-col>
      </el-form-item>
       <el-form-item label="验证码" prop="newCode">
          <el-col :span="15">
            <el-input maxlength="4" :rule="form.newCode" v-model.trim="form.newCode" placeholder="请输入验证码"></el-input>
          </el-col>
          <el-col :span="1">&nbsp;</el-col>
          <el-col :span="8">
            <el-button style="width:100%" :disabled="emailCode.disabled"  @click="handleSendCode(emailCode)">{{emailCode.msg}}</el-button>
          </el-col>
        </el-form-item>
    </el-form>
  </StepTwoDialog>
</template>

<script>
import StepTwoDialog from './StepTwoDialog'
import { genInteractionCodeMethods } from './loginAccountUtil'
export default {
  components: {
    StepTwoDialog
  },
  data() {
    var validtorEmailCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请填写验证码'))
      } else {
        this.$service
          .checkSmsCode({
            code: value,
            emailOrPhone: this.$encrypt(this.form.newData)
          })
          .then(data => {
            if (data.isError) {
              callback(new Error('请输入正确验证码'))
            } else {
              callback()
            }
          })
      }
    }
    return {
      activeStep: 0,
      form: {
        newCode: '',
        oldCode: '',
        newData: '',
        oldData: '',
        phoneOrEmail: this.type
      },
      rules: {
        newCode: [
          { required: true, validator: validtorEmailCode, trigger: 'blur' }
        ]
        // userName: [
        //   { min: 8, max: 20, message: '长度在 8 到 20 个字符', trigger: 'blur' }
        // ]
      },
      emailCode: {
        codeCount: 60,
        msg: '获取验证码',
        timer: null,
        disabled: false
      }
    }
  },
  props: ['type', 'account'],
  computed: {

  },
  methods: {
    // 发送验证码
    handleSendCode(codeObj) {
      this.$refs.form.validateField('newData', msg => {
        if (msg) {
          return
        }
        genInteractionCodeMethods(codeObj, () => {
          this.$service.sendCode({
            email: this.$encrypt(this.form.newData)
          })
        })
      })
    },
    handleAcceptStep(val) {
      this.activeStep = val
    },
    handleFinish() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = this.cloneDeep(this.form)
          params.oldData = this.$encrypt(params.oldData)
          params.newData = this.$encrypt(params.newData)
          this.$service.addEmail(params, '修改成功').then(data => {
            this.$refs.dialog.isVisableDialog = false
          })
        }
      })
    },
    handleDialogClose() {
      this.$refs.form.resetFields()
      this.$refs.dialog.isVisableDialog = false
      this.emailCode = {
        codeCount: 60,
        msg: '获取验证码',
        timer: null,
        disabled: false
      }
    }
  },
  created() {
  }
}
</script>

<style lang="stylus" scoped>
.cc-title
  text-align center
  color #ff8b00
  font-size 18px
  font-weight bold
  padding-bottom 15px
>>>.el-dialog__body
  padding 0
.demo-ruleForm
  max-width 500px
.demo-ruleForm >>>.el-form-item
  margin-bottom 15px
</style>
